import { BitcoinIcon as Bitcoin } from '@/components/icons/BitcoinIcon';
import { DollarIcon as Dollar } from '@/components/icons/DollarIcon';
import type { Bookmaker } from '@/types/bookmaker';

export function PaymentIcons({
  paymentType,
}: {
  paymentType: Bookmaker['attributes']['PaymentType'];
}) {
  const renderPaymentIcons = () => {
    if (paymentType === 'All') {
      return (
        <>
          <Dollar desc="Fiat currency payment icon" title="Fiat Currency" />
          <Bitcoin
            desc="Bitcoin cryptocurrency payment icon"
            title="Cryptocurrency"
          />
        </>
      );
    }

    if (paymentType === 'Crypto') {
      return (
        <Bitcoin
          desc="Bitcoin cryptocurrency payment icon"
          title="Cryptocurrency"
        />
      );
    }

    return <Dollar desc="Fiat currency payment icon" title="Fiat Currency" />;
  };

  return <div className="flex gap-2">{renderPaymentIcons()}</div>;
}
